import { render, staticRenderFns } from "./Photoswipe.vue?vue&type=template&id=281eb8b0&"
import script from "./Photoswipe.vue?vue&type=script&lang=js&"
export * from "./Photoswipe.vue?vue&type=script&lang=js&"
import style0 from "./Photoswipe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports